const workHoursData = [
    {
        id:"1",
        day:"Saturday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"2",
        day:"Sunday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"3",
        day:"Monday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"4",
        day:"Tuesday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"5",
        day:"Wednesday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"6",
        day:"Thursday",
        time:"8:30 AM - 4:30 PM"
    },
    {
        id:"7",
        day:"Friday",
        time:"closed"
    },
]

export default workHoursData;